import ToolbarButtonWithDropdown from '../ToolbarButtonWithDropdown';
import { FontSizePicker } from '../pickers';

const DEFAULT_FONT_SIZE = 14;

export default function FontSizeButton({ editor }) {
  function handleChangeFontSize(value) {
    editor.chain().focus().setFontSize(`${value}px`).run();
  }

  const selectionFontSize = editor.getAttributes('textStyle')?.fontSize
    ? editor.getAttributes('textStyle')?.fontSize.split('px')[0]
    : DEFAULT_FONT_SIZE;

  return (
    <ToolbarButtonWithDropdown
      disabled={!editor.can().chain().focus().setFontSize().run()}
      dropdownComponent={<FontSizePicker onClick={handleChangeFontSize} />}
      aria-label="editor-font-size"
    >
      {selectionFontSize}
    </ToolbarButtonWithDropdown>
  );
}
